import React from "react";
import styles from "./style.module.scss";

const links = [
  { href: "/#process", title: "製造過程" },
  { href: "/#work", title: "事業について" },
  { href: "/#about", title: "会社概要" },
  { href: "/#contact", title: "お問い合わせ" },
];

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <p className={styles.name}>株式会社ミヤザワ</p>
        <div className={styles.links}>
          {links.map((link, idx) => (
            <a href={link.href} key={idx} className={styles.link}>
              {link.title}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
